import * as Tooltip from '~/components/ui/Tooltip';

interface BillingInfoTooltipProps {
  value: string;
}

export const BillingInfoTooltip = ({ value }: BillingInfoTooltipProps) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span className="i-ph:info text-lg text-bolt-ds-iconSecondary mb-1" />
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content side="bottom" avoidCollisions collisionPadding={10} sideOffset={6}>
            <span>{value}</span>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
